/** Search param used in the microwave API. */
export const searchParametersMicrowave = {
    CLIENTS: 'clients',
    MANAGERS: 'managers',
    NAME: 'name',
    SITES: 'sites',
}

/** Search param used in the microwave API. */
export const searchParametersMicrowaveApi = {
    CLIENTS: 'site__customer_name__id__in',
    IDs: 'id__in',
    MANAGERS: 'site__customer_name__client__id__in',
    NAME: 'name__icontains',
    SITES: 'site__id__in',
}
